import {Moment} from 'moment';
import {ICustomer} from './customer.model';
import {ITransaction} from "./transaction.model";
import {IProject} from "./project.model";
import {IOrganization} from "./organization.model";
import {IEmployee} from "./employee.model";
import {IStep} from "./step.model";

export interface IProjectItems {
  id?: number;
  title?: string;
  // startDate?: Moment;
  // customer?: ICustomer;
  project?: IProject;
  organization?: IOrganization;
  itemName?: string;
  code?: string;
  address?: string;
  audience?: string;
  phone?: any;
  step_number?: any;
  status?: string;
  reminderMe_time?: string;
  reminderMe_type?: string;
  reminderMin?: any;
  reminderMe?: boolean;
  reminderMe_edit?: boolean;

  color?: string;
  close_status?: string;
  step?: IStep;
  project_step?: string;
  updateDate?: string;
  description?: string;
  score?: any;
  lastModifiedDate?: any;
  last_modified_date?: any;
  createdDate?: any;
  created_date?: any;
  startDate?: any;
  endDate?: any;
  endDateReal?: any;
  percentProgress?: any;
  start?: string;
  end?: string;
  endReal?: string;
  createdBy?: string;
  lastModifiedBy?: string;
  closed?: boolean;
  needValidation?: boolean;
  countValidation?: any;
  loadFromCoding?: boolean;
  transactions?: ITransaction[];
  employee_str?: any;
  employee?: IEmployee;


}

export class ProjectItems implements IProjectItems {

  constructor(public id?: number,
              public title?: string,
              public address?: string,
              public step?: IStep,
              public project_step?: string,
              public description?: string,
              public startDate?: any,
              public endDate?: any,
              public customer?: ICustomer,
              public createdBy?: string,
              public lastModifiedBy?: string,
              public closed?: boolean,
              public lastModifiedDate?: any,
              public created_date?: any,
              public last_modified_date?: any,
              public step_number?: any,
              public transactions?: ITransaction[],
              public createdDate?: any) {
  }
}
